import { DiscussionCard } from "./DiscussionCard";
import type { Tables } from "@/integrations/supabase/types";

interface DiscussionListProps {
  discussions: (Tables<"property_discussions"> & {
    profiles: Pick<Tables<"profiles">, "first_name" | "last_name"> | null;
    replies: (Tables<"property_discussions"> & {
      profiles: Pick<Tables<"profiles">, "first_name" | "last_name"> | null;
    })[];
  })[];
  onReply: () => void;
}

export const DiscussionList = ({ discussions, onReply }: DiscussionListProps) => {
  return (
    <div className="space-y-4">
      {discussions?.map((discussion) => (
        <DiscussionCard
          key={discussion.id}
          discussion={discussion}
          onReply={onReply}
        />
      ))}
    </div>
  );
};